import {useContext, useEffect, useState} from "react";
import {SalvoContext} from "../contexts/SalvoContext";

// Provides access to company id of the current user (even if selectedCompany is not set)
export default function useCompanyId() {
    const { selectedCompany, companyId } = useContext(SalvoContext);

    // Initialize state with the correct value
    const initialCompanyId = selectedCompany ? selectedCompany.id : companyId;
    const [currentCompanyId, setCurrentCompanyId] = useState(initialCompanyId);

    useEffect(() => {
        if (selectedCompany) {
            setCurrentCompanyId(selectedCompany.id);
        } else {
            setCurrentCompanyId(companyId);
        }
    }, [selectedCompany, companyId]);

    return currentCompanyId;
}